'use client'

import { useEffect } from 'react';
import { useSearchStore } from '@/core/stores/searchStore';
import useSetSearchParams from '@/hooks/useSetSearchParams';

const SearchParamsSetter: React.FC = () => {
    const setParams = useSearchStore((state) => state.setParams);
    const { params: {
        placeId = '',
        city = '',
        lat = '',
        lng = '',
        passenger = '',
        std = '',
        end = '',
    } } = useSetSearchParams()

    useEffect(() => {
        setParams({
            placeId,
            city,
            lat,
            lng,
            passenger,
            std,
            end,
        });
    }, [placeId, city, lat, lng, passenger, std, end,]);

    return null; // This component doesn't render anything
};

export default SearchParamsSetter;
